import React from 'react';
import { Trends } from 'src/features/MM/components/templates/Trends';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const TrendsPage: React.FC = () => {
  return (
    <PageModelLayout
      pageTitle="Trends"
      filterBar={<FilterBar includeAggregation includeDimension />}
      extraButtons={<GenAIActionButtons />}>
      <Trends />
    </PageModelLayout>
  );
};
